<template>
  <div>
    <el-form ref="formForReadPoint" label-width="60px">
      <!-- v-model="contentInfo.artist" -->
      <el-form-item label="讲解者: ">
        <el-input
          v-model="contentInfo.artist"
          :disabled="doWhatTemp === 'view'"
          placeholder=""
          style="width:200px"
        ></el-input>
      </el-form-item>
      <el-form-item label="原音：">
        <div class="flex_row_start_center">
          <el-upload
            action="/aries-api/resource/upload"
            :data="uploadData"
            accept="audio/mp3"
            :before-upload="handleBeforeUpload"
            :on-success="handleAudioSuccess"
            :show-file-list="false"
            style="padding-right: 10px"
            :disabled="doWhat === 'view'"
          >
            <el-button
              size="small"
              type="primary"
              :disabled="doWhat === 'view'"
            >
                     上传原音
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </el-upload>
          <AudioPlayer
            :audioUrl="pointEditor.audio"
            v-if="pointEditor.audio != ''"
          ></AudioPlayer>
          <span
            v-if="pointEditor.duration != null"
            style="font-size: 13px; margin-right: 10px; margin-left: 10px"
            >时长：{{ pointEditor.duration }}秒</span
          >
          <el-button
            v-if="pointEditor.audio != ''"
            type="danger"
            size="small"
            @click="delAudio"
            :disabled="doWhat == 'view'"
            icon="el-icon-delete"
            >删除音频</el-button
          >
        </div>
      </el-form-item>
      <br />
      <el-form-item label="讲解：">
        <div class="flex_row_start_center">
          <el-upload
            action="/aries-api/resource/upload"
            :data="uploadData"
            accept="audio/mp3"
            :before-upload="handleBeforeUpload"
            :on-success="handleExplainAudioSuccess"
            :show-file-list="false"
            style="padding-right: 10px"
            :disabled="doWhat === 'view'"
          >
            <el-button
              size="small"
              type="primary"
              :disabled="doWhat == 'view'"
              style="width: 123px; height: 35px"
            >
              上传讲解
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </el-upload>
          <AudioPlayer
            :audioUrl="pointEditor.explainAudio"
            v-if="pointEditor.explainAudio != ''"
          ></AudioPlayer>
          <span
            v-if="pointEditor.explainAudioDuration != null"
            style="font-size: 13px; margin-right: 10px; margin-left: 10px"
            >时长：{{ pointEditor.explainAudioDuration }}秒</span
          >
          <el-button
            v-if="pointEditor.explainAudio != ''"
            type="danger"
            size="small"
            @click="delExplainAudio"
            :disabled="doWhat == 'view'"
            icon="el-icon-delete"
            >删除音频</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>


<script>
import AudioPlayer from "../AudioPlayer";
import { checkFormat } from "../../book";
export default {
  name: "PointInteract",
  components: { AudioPlayer },
  data() {
    return {
      uploadData: { isOnlyMP3: "true", pdfToPng: "false" },
      
    };
  },
  props: {
    pointEditor: {
      type: Object,
      default() {
        let formVal = {
          audio: "",
          duration: null,
          explainAudio: "",
          explainAudioDuration: null,
        };
        return formVal;
      },
    },
    doWhatTemp: {
      type: String,
      default: "",
    },
      contentInfo: {
      type: Object,
      default() {
        let temp = {
          artist: "",
        };
        return temp;
      },
    },
    ind: {
      type: Number,
      default: null,
    },
    doWhat: {
      type: String,
      default: "",
    },
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    handleBeforeUpload(file) {
      return checkFormat(file, "audio");
    },
    handleAudioSuccess(response) {
      this.pointEditor.audio = response.data[0].url;
      this.pointEditor.duration = response.data[0].length;
      this.$emit("backToEdit", "addAudio", this.ind);
    },
    handleExplainAudioSuccess(response) {
      this.pointEditor.explainAudio = response.data[0].url;
      this.pointEditor.explainAudioDuration = response.data[0].length;
      this.$emit("backToEdit", "addExplainAudio", this.ind);
    },
    delAudio() {
      this.pointEditor.audio = "";
      this.pointEditor.duration = null;
      this.$emit("backToEdit", "delAudio", this.ind);
    },
    delExplainAudio() {
      this.pointEditor.explainAudio = "";
      this.pointEditor.explainAudioDuration = null;
      this.$emit("backToEdit", "delExplainAudio", this.ind);
    },
  },
};
</script>

<style lang="less">
</style>


// WEBPACK FOOTER //
// PointInteract.vue?f4fb8fc4